<template>
  <main class="main">
    <div class="main__container">
      <slot/>
    </div>
  </main>
</template>

<script>
export default {
  name: 'SMain'
}
</script>

<style scoped>
.main {
  padding: calc(var(--grid-spacing) / 2) 0;
  background-color: var(--color-background);
}

@media (min-width: 800px) {
  .main {
    padding: var(--grid-spacing) 0;
  }
}

.main__container {
  width: var(--container-width);
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--container-padding);
}
</style>
